import React from 'react';
import GlassButton from '../../components/Aero/GlassButton';
import AeroIcon from '../../components/Aero/AeroIcon';
import { AeroStatus } from '../../components/Aero/AeroHomeParts';

const STATUS_WORD = { open: 'Open', closed: 'Closed', draft: 'Draft' };

/**
 * "Tests of this site" on a site's Overview: each test copy of the site (and
 * an older test kept on the site itself, marked "On this site"), each opening
 * the test, plus "Test this site" to make another copy. A view: rows come from
 * UserTesting/testCopy.siteTestRows.
 *
 *   tests    [{ id, title, link, statusKind, madeLabel, own }]
 *   onOpen   (id) => void
 *   onTest   () => void, or null for no button (shared sites)
 *   testing  true while a copy is being made
 */
export default function SiteTestsCard({ tests = [], onOpen, onTest = null, testing = false }) {
  return (
    <div className="aero-card aero-stests">
      <div className="aero-card-head">
        <h3>Tests of this site</h3>
        {onTest && (
          <GlassButton fill="glass" size="sm" onClick={onTest} disabled={testing} aria-label="Test this site">
            <AeroIcon name="plus" />
            <span>{testing ? 'Making a copy…' : 'Test this site'}</span>
          </GlassButton>
        )}
      </div>
      {tests.length === 0 ? (
        <p className="aero-stests-empty">
          No tests yet. A test is a copy of the live version with its own link, so your site doesn’t change.
        </p>
      ) : (
        <ul className="aero-stests-list">
          {tests.map((t) => (
            <li key={t.id}>
              <button type="button" className="aero-stests-row" onClick={() => onOpen(t.id)}>
                <span className="aero-stests-main">
                  <span className="aero-stests-name">{t.title}</span>
                  <span className="aero-stests-meta">
                    {t.link && <span className="aero-stests-link">{t.link}</span>}
                    {t.own ? <span>On this site</span> : t.madeLabel && <span>{t.madeLabel}</span>}
                  </span>
                </span>
                <AeroStatus kind={t.statusKind}>{STATUS_WORD[t.statusKind]}</AeroStatus>
                <AeroIcon name="right" className="aero-stests-chev" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
